import $ from 'jquery';

let numHiddenInputs = $('#hp_cc_lists input[type="hidden"]').length;

$('#hp_cc_select').on('change', function () {
  let selectedValue = $(this).val();

  if (selectedValue === 'Registered Dietitian') {
    // If the selected value is "Registered Dietitian" and there are less than two hidden inputs, do nothing.
    if ($('#hp_cc_lists input[type="hidden"]').length < 2) {
      return;
    }
    // Otherwise, add the hidden inputs back.
    else {
      for (let i = 1; i < numHiddenInputs; i++) {
        $('#hp_cc_lists > div').append(
          '<input type="hidden" value="1895801223" name="ctct-395[]">'
        );
      }
      numHiddenInputs = $('#hp_cc_lists input[type="hidden"]').length;
    }
  } else {
    // If the selected value is anything else, remove the last hidden input if there are more than two hidden inputs.
    if ($('#hp_cc_lists input[type="hidden"]').length > 2) {
      $('#hp_cc_lists > div input[type="hidden"]:last-child').remove();
      numHiddenInputs = $('#hp_cc_lists input[type="hidden"]').length;
    }
  }
});
